
      var _image, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 27,
  height: 29,
  textRendering: "geometricPrecision",
  viewBox: "0 0 27 29"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "calendar_0ea0c10301ff7d53__a",
  width: 27,
  height: 29,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAAwFBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9kjpChAAAAP3RSTlMAvzFXzvAg/fxH/uQ62/v65xYq9BkOIQUs70HpBt/MQxWZnnBgPxok+ZztjzRdtOByypibqWxKF8KBxe7rMxieYCuIAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAq0lEQVR42u2SNxLCQAwAZdIZWToncs4558z/f8XZY4bmaGDo2GJHmi3UCOAbCoG8vFIuq+RmXqmNHYAuNgEasqb2cjEKE6INromOYkk0NUdEhHadqAewEop7IBRPwmnggoEOn/HC7KDPPBc2M6PJLM0YGCIO15MHsD/s1IXZQmk8BLDCtk3pcIKGphYhg+YndYjong7r337Qqgkdtmot8QZ5g0opraf/8bs/ADw2D8B6YoCQAAAAAElFTkSuQmCC",
  width: 27,
  height: 29,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAAwFBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9kjpChAAAAP3RSTlMAvzFXzvAg/fxH/uQ62/v65xYq9BkOIQUs70HpBt/MQxWZnnBgPxok+ZztjzRdtOByypibqWxKF8KBxe7rMxieYCuIAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAq0lEQVR42u2SNxLCQAwAZdIZWToncs4558z/f8XZY4bmaGDo2GJHmi3UCOAbCoG8vFIuq+RmXqmNHYAuNgEasqb2cjEKE6INromOYkk0NUdEhHadqAewEop7IBRPwmnggoEOn/HC7KDPPBc2M6PJLM0YGCIO15MHsD/s1IXZQmk8BLDCtk3pcIKGphYhg+YndYjong7r337Qqgkdtmot8QZ5g0opraf/8bs/ADw2D8B6YoCQAAAAAElFTkSuQmCC",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAADFBMVEVMaXGzs7P///+lZv87LCVLAAAABHRSTlMAAgEDMAXSDwAAAAlwSFlzAAAD6AAAA+gBtXtSawAAABxJREFUeNpjYKAAMDIwkaCaGaqH1oD2NoyCEQkAGUwACWJa9AwAAAAASUVORK5CYII=",
  width: 27,
  height: 29,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAADFBMVEVMaXGzs7P///+lZv87LCVLAAAABHRSTlMAAgEDMAXSDwAAAAlwSFlzAAAD6AAAA+gBtXtSawAAABxJREFUeNpjYKAAMDIwkaCaGaqH1oD2NoyCEQkAGUwACWJa9AwAAAAASUVORK5CYII=",
  preserveAspectRatio: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#calendar_0ea0c10301ff7d53__a)",
  shapeRendering: "crispEdges",
  d: "M0 0h27v29H0z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"27\" height=\"29\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 27 29\"><defs><mask id=\"layer-0\" width=\"27\" height=\"29\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAAwFBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9kjpChAAAAP3RSTlMAvzFXzvAg/fxH/uQ62/v65xYq9BkOIQUs70HpBt/MQxWZnnBgPxok+ZztjzRdtOByypibqWxKF8KBxe7rMxieYCuIAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAq0lEQVR42u2SNxLCQAwAZdIZWToncs4558z/f8XZY4bmaGDo2GJHmi3UCOAbCoG8vFIuq+RmXqmNHYAuNgEasqb2cjEKE6INromOYkk0NUdEhHadqAewEop7IBRPwmnggoEOn/HC7KDPPBc2M6PJLM0YGCIO15MHsD/s1IXZQmk8BLDCtk3pcIKGphYhg+YndYjong7r337Qqgkdtmot8QZ5g0opraf/8bs/ADw2D8B6YoCQAAAAAElFTkSuQmCC\" width=\"27\" height=\"29\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAAwFBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9kjpChAAAAP3RSTlMAvzFXzvAg/fxH/uQ62/v65xYq9BkOIQUs70HpBt/MQxWZnnBgPxok+ZztjzRdtOByypibqWxKF8KBxe7rMxieYCuIAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAq0lEQVR42u2SNxLCQAwAZdIZWToncs4558z/f8XZY4bmaGDo2GJHmi3UCOAbCoG8vFIuq+RmXqmNHYAuNgEasqb2cjEKE6INromOYkk0NUdEhHadqAewEop7IBRPwmnggoEOn/HC7KDPPBc2M6PJLM0YGCIO15MHsD/s1IXZQmk8BLDCtk3pcIKGphYhg+YndYjong7r337Qqgkdtmot8QZ5g0opraf/8bs/ADw2D8B6YoCQAAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAADFBMVEVMaXGzs7P///+lZv87LCVLAAAABHRSTlMAAgEDMAXSDwAAAAlwSFlzAAAD6AAAA+gBtXtSawAAABxJREFUeNpjYKAAMDIwkaCaGaqH1oD2NoyCEQkAGUwACWJa9AwAAAAASUVORK5CYII=\" id=\"convert2-underlay\" width=\"27\" height=\"29\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAADFBMVEVMaXGzs7P///+lZv87LCVLAAAABHRSTlMAAgEDMAXSDwAAAAlwSFlzAAAD6AAAA+gBtXtSawAAABxJREFUeNpjYKAAMDIwkaCaGaqH1oD2NoyCEQkAGUwACWJa9AwAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\"/><rect width=\"27\" height=\"29\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\" shape-rendering=\"crispEdges\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/calendar.0ea0c10301ff7d53cb5594906ef07ef1.svg"),
        {
          React: SvgCalendar,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      